import React from 'react';
export var SessionCropIcon = function SessionCropIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 30 30"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.5V2C5.5 1.171 6.172 0.5 7 0.5C7.828 0.5 8.5 1.171 8.5 2V21.5H28C28.828 21.5 29.5 22.171 29.5 23C29.5 23.828 28.828 24.5 28 24.5H24.5V28C24.5 28.828 23.828 29.5 23 29.5C22.172 29.5 21.5 28.828 21.5 28V24.5H7C6.172 24.5 5.5 23.828 5.5 23V8.5H2C1.172 8.5 0.5 7.828 0.5 7C0.5 6.171 1.172 5.5 2 5.5H5.5ZM10.5 7C10.5 6.171 11.172 5.5 12 5.5H23.001C23.829 5.5 24.501 6.171 24.501 7V18C24.501 18.828 23.829 19.5 23.001 19.5C22.173 19.5 21.501 18.828 21.501 18V8.5H12C11.172 8.5 10.5 7.828 10.5 7Z",
    fill: "#AA9B8C"
  }));
};